export default __webpack_public_path__ + "static/media/logo_sin.2ad840e4.svg";